export default __webpack_public_path__ + "static/media/hero-bg-2.564eff85.png";